import { useTranslation } from 'react-i18next'
import { useFormContext } from 'react-hook-form'
import { Stack, Box } from '@mui/material'
import { ControlledTextField } from '@/components/inputs'

export type QuotationAgreementsFormData = {
  [key: string]: {
    id?: string
    agreement: string
  }
}

export type QuotationAgreementsFormDataProps = {
  index: string
}

export const QuotationAgreementsForm = ({
  index,
}: QuotationAgreementsFormDataProps) => {
  const { t } = useTranslation()

  const { control } = useFormContext<QuotationAgreementsFormData>()

  return (
    <Stack
      direction="row"
      spacing={2}
      borderRadius={2.5}
      p={4}
      bgcolor="grey.50"
      width="100%"
    >
      <Stack
        direction={{ xs: 'column', xl: 'row' }}
        justifyContent="flex-start"
        spacing={4}
        width="100%"
      >
        <Box width="100%">
          <ControlledTextField
            name={`${index}.agreement`}
            control={control}
            placeholder={t('quotations:placeholders.agreement')}
            errorMessagePrefix=""
          />
        </Box>
      </Stack>
    </Stack>
  )
}
